exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* width */\n.overflow-y-scroll[data-v-389f2052]::-webkit-scrollbar {\n  width: 5px;\n}\n\n/* Track */\n.overflow-y-scroll[data-v-389f2052]::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n/* Handle */\n.overflow-y-scroll[data-v-389f2052]::-webkit-scrollbar-thumb {\n  background: #adadad;\n}\n\n/* Handle on hover */\n.overflow-y-scroll[data-v-389f2052]::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n", ""]);

// exports
